import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { IconCreateBlack } from '../../../assets';
// import { IconPublish, IconCreateBlack } from '../../../assets';
import { TOUR_TRASH_TRANSLATION } from '../../../constants/define/translation';

interface TourTrashPageHeaderProps {
  onOpenTourTrashModal?: () => void;
  extraDropdown?: any;
}

export const TourTrashPageHeader = (props: TourTrashPageHeaderProps) => {
  const { t } = useTranslation(TOUR_TRASH_TRANSLATION);
  const { onOpenTourTrashModal, extraDropdown } = props;

  const extra: ExtraHeaderPage[] = [
    {
      key: 1,
      text: t('header.button.create'),
      bgWhite: 'true',
      onClick: onOpenTourTrashModal,
      icon: <IconCreateBlack />,
    },
    // { key: 2, text: t('header.button.publish'), icon: <IconPublish /> },
  ];

  return <ContentPageHeader title={t('title.tourTrash')} extra={extra} extraDropdown={extraDropdown} />;
};
